import axios from 'axios';
import { API_BASE_URL, isElectron } from '../config';

const baseURL = API_BASE_URL;

if (isElectron) {
  console.log('Running in Electron environment');
} else {
  console.log('Running in browser environment');
}


console.log('API Base URL:', baseURL);

export const createApiClient = (accessToken) => {
  const client = axios.create({ 
    baseURL,
  });

  // Check for connection credentials in localStorage
  if (typeof window !== 'undefined') {
    const username = localStorage.getItem('server_username');
    const password = localStorage.getItem('server_password');
    if (username && password) {
      try {
        const auth = btoa(`${username}:${password}`);
        client.defaults.headers.common['Authorization'] = `Basic ${auth}`;
      } catch (e) {
        console.error('Failed to encode Basic Auth credentials:', e);
      }
    }
  }

  // Add request interceptor for logging
  client.interceptors.request.use(
    (config) => {
      console.log('Request:', config.method.toUpperCase(), config.url);
      return config;
    },
    (error) => {
      console.error('Request Error:', error);
      return Promise.reject(error);
    }
  );

  // Add response interceptor for error handling
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        console.error('Response Error:', {
          status: error.response.status,
          data: error.response.data,
          headers: error.response.headers,
        });
      } else if (error.request) {
        // The request was made but no response was received
        console.error('No response received:', error.request);
        error.message = 'No response from server. Please check your connection.';
      } else {
        // Something happened in setting up the request
        console.error('Request setup error:', error.message);
      }
      return Promise.reject(error);
    }
  );

  // Bearer token (JWT) takes precedence for application requests
  if (accessToken) {
    client.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  }

  return client;
};
